<template>
  <article class="article-shell">
    <header v-if="currentNote" class="article-hero article-hero-compact">
      <div class="article-hero-copy">
        <div class="article-hero-top">
          <span class="article-eyebrow">{{ currentNote.categoryTitle }} / 正文</span>
          <RouterLink class="article-back-link" to="/tech-notes">
            返回 ↩
          </RouterLink>
        </div>
        <h1>{{ currentNote.title }}</h1>
        <p v-if="currentNote.heroSummary || currentNote.summary">
          {{ currentNote.heroSummary || currentNote.summary }}
        </p>
        <div class="article-meta">
          <span>{{ currentNote.categoryTitle }}</span>
          <span>{{ currentNote.date }}</span>
          <span>{{ currentNote.reading || "阅读时间 5 分钟" }}</span>
        </div>
      </div>
    </header>

    <section class="article-reader-card">
      <ArticleBlocksRenderer
        v-if="currentNote"
        class="article-reader-body"
        :html="currentNote.contentHtml"
        :blocks="currentNote.contentBlocks"
      />
      <div v-else class="article-reader-body article-rich-content">
        <div class="article-empty">还没有可展示的技术手记文章。</div>
      </div>
    </section>
  </article>
</template>

<script setup>
import { computed, watchEffect } from "vue";
import { RouterLink, useRoute } from "vue-router";
import ArticleBlocksRenderer from "@/components/ArticleBlocksRenderer.vue";
import { useContentStore } from "@/store/contentStore";

const route = useRoute();
const { techNotes } = useContentStore();

const currentNote = computed(() => {
  const matched = techNotes.value.find((item) => item.slug === route.params.slug);
  return matched || techNotes.value[0] || null;
});

watchEffect(() => {
  document.title = currentNote.value
    ? `圣域空间 | ${currentNote.value.title}`
    : "圣域空间 | 技术手记详情";
});
</script>
